import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

// Tipos de Vendas
import { ConfigPedidoTipoVendaBadgeComponent, ConfigPedidoTipoVendaBadgeAmostraComponent, ConfigPedidoTipoVendaBadgeBonificacaoComponent, ConfigPedidoTipoVendaBadgeConsignacaoComponent, ConfigPedidoTipoVendaBadgeOutroComponent, ConfigPedidoTipoVendaBadgeRemessaComponent, ConfigPedidoTipoVendaBadgeSimulacaoComponent, ConfigPedidoTipoVendaBadgeOrcamentoComponent, ConfigPedidoTipoVendaBadgeVendaComponent } from './tipo-venda/badge';
import { ConfigPedidoTipoVendaMultiselectComponent } from './tipo-venda/multiselect';
import { ConfigPedidoTipoVendaPipe, ConfigPedidoTipoVendaAbreviacaoPipe, ConfigPedidoTipoVendaSinonimoPipe } from './tipo-venda/pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        // Tipos de Vendas
        ConfigPedidoTipoVendaBadgeComponent,
        ConfigPedidoTipoVendaBadgeAmostraComponent,
        ConfigPedidoTipoVendaBadgeBonificacaoComponent,
        ConfigPedidoTipoVendaBadgeConsignacaoComponent,
        ConfigPedidoTipoVendaBadgeOutroComponent,
        ConfigPedidoTipoVendaBadgeRemessaComponent,
        ConfigPedidoTipoVendaBadgeSimulacaoComponent,
        ConfigPedidoTipoVendaBadgeOrcamentoComponent,
        ConfigPedidoTipoVendaBadgeVendaComponent,
        ConfigPedidoTipoVendaMultiselectComponent,
        ConfigPedidoTipoVendaPipe,
        ConfigPedidoTipoVendaAbreviacaoPipe,
        ConfigPedidoTipoVendaSinonimoPipe
    ],
    exports: [
        // Tipos de Vendas
        ConfigPedidoTipoVendaBadgeComponent,
        ConfigPedidoTipoVendaBadgeAmostraComponent,
        ConfigPedidoTipoVendaBadgeBonificacaoComponent,
        ConfigPedidoTipoVendaBadgeConsignacaoComponent,
        ConfigPedidoTipoVendaBadgeOutroComponent,
        ConfigPedidoTipoVendaBadgeRemessaComponent,
        ConfigPedidoTipoVendaBadgeSimulacaoComponent,
        ConfigPedidoTipoVendaBadgeOrcamentoComponent,
        ConfigPedidoTipoVendaBadgeVendaComponent,
        ConfigPedidoTipoVendaMultiselectComponent,
        ConfigPedidoTipoVendaPipe,
        ConfigPedidoTipoVendaAbreviacaoPipe,
        ConfigPedidoTipoVendaSinonimoPipe
    ],
    providers: [
        // Tipos de Vendas
        ConfigPedidoTipoVendaPipe,
        ConfigPedidoTipoVendaAbreviacaoPipe,
        ConfigPedidoTipoVendaSinonimoPipe
    ]
})
export class ConfigPedidoModule { }
